module.exports = __webpack_public_path__ + "static/media/28.23ce0918.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/28.JPG
// module id = 471
// module chunks = 0